import { SelectOption, SourceType } from '@pulseops/common'
import { pipe } from 'fp-ts/lib/function'
import * as O from 'fp-ts/lib/Option'
export namespace PCReason {
  export enum ActionEnum {
    // NEW = 'NEW',
    // REN = 'REN',
    // OPL = 'OPL',
    // APL = 'APL',
    // OTH_REINS = 'OTH-REINS',
    // OTH_TOPUP = 'OTH-TOPUP',
    // OTH_CHANGE_POLICY = 'OTH_CHANGE_POLICY'
    J = 'MSP_R_RPJ',
    N = 'MSP_R_RPN',
    L = 'MSP_R_RPL',
    R = 'MSP_R_RPR',
    G = 'MSP_R_RPG',
    A = 'MSP_C_RTA'
  }

  const ReceiptAction = [ActionEnum.J, ActionEnum.N, ActionEnum.L, ActionEnum.R, ActionEnum.G]

  const NoncashAction = [ActionEnum.J, ActionEnum.L, ActionEnum.N]

  const JournalAction = [ActionEnum.J, ActionEnum.A, ActionEnum.L]

  const PCActionRaw: {
    code: string
    des: string
    about: string
  }[] = [
      {
        code: 'MSP_R_RPJ',
        des: 'Action J',
        about: 'Action J'
      },
      {
        code: 'MSP_R_RPN',
        des: 'Action N',
        about: 'Action N'
      },
      {
        code: 'MSP_R_RPL',
        des: 'Action L',
        about: 'Action L'
      },
      {
        code: 'MSP_R_RPR',
        des: 'Action R',
        about: 'Action R'
      },
      {
        code: 'MSP_R_RPG',
        des: 'Action G',
        about: 'Action G'
      },
      {
        code: 'MSP_C_RTA',
        des: 'Action A',
        about: 'Action A'
      }
      // {
      //   code: 'REN',
      //   des: 'Thanh toán phí bảo hiểm cho hợp đồng mới',
      //   about: 'Phí định kỳ'
      // },
      // {
      //   code: 'OPL',
      //   des: 'Thanh toán phí bảo hiểm cho hợp đồng mới',
      //   about: 'Hoàn trả tạm ứng'
      // },
      // {
      //   code: 'APL',
      //   des: 'Thanh toán phí bảo hiểm cho hợp đồng mới',
      //   about: 'Hoàn trả phí tự động'
      // },
      // {
      //   code: 'NEW',
      //   des: 'Thanh toán phí bảo hiểm cho hợp đồng mới',
      //   about: 'Phí khác-Phí hồ sơ mới'
      // },
      // {
      //   code: 'OTH-REINS',
      //   des: '',
      //   about: 'Phí khác-Phí Khôi phục hợp đồng'
      // },
      // {
      //   code: 'OTH-TOPUP',
      //   des: '',
      //   about: 'Phí khác-Phí đầu tư thêm'
      // },
      // {
      //   code: 'OTH_CHANGE_POLICY',
      //   des: '',
      //   about: 'Phí khác-Phí Điều chỉnh hợp đồng'
      // }
    ]

  const PCMapActionData = new Map<string, Map<string, string>>(
    PCActionRaw.map((item) => [
      item.code,
      new Map<string, string>([
        ['des', item.des],
        ['about', item.about]
      ])
    ])
  )

  export const getDescriptionActionByCode = (code: string) => PCMapActionData.get(code)?.get('des') ?? code

  export const getAboutActionByCode = (code: string) => PCMapActionData.get(code)?.get('about') ?? code

  export const getSelectOptions = (): SelectOption[] => // get action for receipt
    ReceiptAction.map((item) => ({
      value: item as string,
      label: getDescriptionActionByCode(item as string)
    }))

  export const getActionNonCash = (): SelectOption[] => // get action for Noncash
    NoncashAction.map((item) => ({
      value: item as string,
      label: getDescriptionActionByCode(item as string)
    }))

  export const getActionJournal = (): SelectOption[] =>
    JournalAction.map((item) => ({
      value: item as string,
      label: getDescriptionActionByCode(item as string)
    }))

  export enum ReasonEnum {
    NEW = 'NEW',
    REN = 'REN',
    OPL = 'OPL',
    APL = 'APL'
  }

  const PCReasonRaw: {
    code: string
    des: string
    about: string
  }[] = [
      {
        code: 'REN',
        des: 'Thanh toán phí bảo hiểm định kỳ',
        about: 'Phí định kỳ'
      },
      {
        code: 'OPL',
        des: 'Hoàn trả tạm ứng từ giá trị hoàn lại',
        about: 'Hoàn trả tạm ứng'
      },
      {
        code: 'APL',
        des: 'Hoàn trả phí tự động',
        about: 'Hoàn trả phí tự động'
      },
      {
        code: 'NEW',
        des: 'Thanh toán phí bảo hiểm cho hợp đồng mới',
        about: 'Phí khác-Phí hồ sơ mới'
      },
      {
        code: 'OTH',
        des: 'Lý do khác',
        about: 'Lý do khác'
      },
      {
        code: 'LOA',
        des: 'Hoàn trả khoản giảm thu nhập đầu tư',
        about: 'Hoàn trả khoản giảm thu nhập đầu tư'
      },
      {
        code: 'RDR',
        des: 'Phí các sản phẩm bảo hiểm bán cùng',
        about: 'Phí các sản phẩm bảo hiểm bán cùng'
      },
      {
        code: 'ADJ',
        des: 'Phí điều chỉnh hợp đồng',
        about: 'Phí điều chỉnh hợp đồng'
      },
      {
        code: 'TPU',
        des: 'Phí đầu tư thêm',
        about: 'Phí đầu tư thêm'
      },
      {
        code: 'REI',
        des: 'Phí khôi phục hợp đồng',
        about: 'Phí khôi phục hợp đồng'
      }
    ]

  const PCMapReasonData = new Map<string, Map<string, string>>(
    PCReasonRaw.map((item) => [
      item.code,
      new Map<string, string>([
        ['des', item.des],
        ['about', item.about]
      ])
    ])
  )

  export const getDescriptionReasonByCode = (code: string) => PCMapReasonData.get(code)?.get('des') ?? code

  export const getAboutReasonByCode = (code: string) => PCMapReasonData.get(code)?.get('about') ?? code

  export const getSelecReasonOptions = (): SelectOption[] =>
    PCReasonRaw.map((item) => ({ value: item.code, label: item.about }))
}

export namespace SacsData {
  export const SacsCodeRaw: { code: string; vi: string; en: string }[] = [
    {
      code: 'LN',
      vi: 'Policy Loan and APL',
      en: 'Policy Loan and APL'
    },
    {
      code: 'LP',
      vi: 'Life Payer Ledger (Contract)',
      en: 'Life Payer Ledger (Contract)'
    },
    {
      code: 'SC',
      vi: 'Company Suspense',
      en: 'Company Suspense'
    }
  ]

  export const SacsCodeMapData = new Map<string, Map<string, string>>(
    SacsCodeRaw.map((item) => [
      item.code,
      new Map<string, string>([
        ['vi', item.vi],
        ['en', item.en]
      ])
    ])
  )

  export const getSacsCodeByCode = (code: string) => (languageCode: string) => ({
    label: `${code} - ${SacsCodeMapData.get(code)?.get(languageCode) ?? code}`,
    value: code
  })

  export const getOptionsCodeByCode =
    (...codes: string[]) =>
      (languageCode: string): SelectOption[] => {
        return codes.map((c) => getSacsCodeByCode(c)(languageCode))
      }

  export const getOptionsCode = (languageCode: string) =>
    SacsCodeRaw.map((s) => getSacsCodeByCode(s.code)(languageCode))

  export const SacsTypeRaw: { code: string; vi: string; en: string }[] = [
    {
      code: 'VP',
      vi: 'Premium Deposit - Principal',
      en: 'Premium Deposit - Principal'
    },
    {
      code: 'PT',
      vi: 'Contract Premium Tolerance',
      en: 'Contract Premium Tolerance'
    },
    {
      code: 'S',
      vi: 'Contract Suspense',
      en: 'Contract Suspense'
    },
    {
      code: 'U',
      vi: 'Receipt for new ILP',
      en: 'Receipt for new ILP'
    },
    {
      code: 'AO',
      vi: 'APL Principal',
      en: 'APL Principal'
    },
    {
      code: 'AI',
      vi: 'APL Interest',
      en: 'APL Interest'
    },
    {
      code: 'LO',
      vi: 'Policy Loan Principal',
      en: 'Policy Loan Principal'
    },
    {
      code: 'LI',
      vi: 'Policy Loan Interest',
      en: 'Policy Loan Interest'
    },
    {
      code: 'E1',
      vi: 'Contract Premium Discount',
      en: 'Contract Premium Discount'
    },
    {
      code: 'I',
      vi: 'Suspense In',
      en: 'Suspense In'
    }
  ]

  export const SacsTypeMapData = new Map<string, Map<string, string>>(
    SacsTypeRaw.map((item) => [
      item.code,
      new Map<string, string>([
        ['vi', item.vi],
        ['en', item.en]
      ])
    ])
  )

  export const getSacsTypeByCode = (code: string) => (languageCode: string) => ({
    label: `${code} - ${SacsTypeMapData.get(code)?.get(languageCode) ?? code}`,
    value: code
  })

  export const getOptionsTypeByCode =
    (...codes: string[]) =>
      (languageCode: string): SelectOption[] => {
        return codes.map((c) => getSacsTypeByCode(c)('vi'))
      }

  export const getOptionsTypes = (languageCode: string) =>
    SacsTypeRaw.map((sac) => getSacsTypeByCode(sac.code)(languageCode))
}

export namespace MappingJournal {
  export const RawTableCode: {
    action: PCReason.ActionEnum
    tables: {
      from: string
      to: string[]
    }[]
  }[] = [
      {
        action: PCReason.ActionEnum.J,
        tables: [
          {
            from: 'LP_S',
            to: ['LN_VP']
          },
          {
            from: 'LN_VP',
            to: ['LP_S']
          },
          {
            from: 'LP_E1',
            to: ['LN_VP']
          }
        ]
      },
      {
        action: PCReason.ActionEnum.A,
        tables: [
          {
            from: 'LP_S',
            to: ['LP_U']
          },
          {
            from: 'LP_U',
            to: ['LP_S']
          },
          {
            from: 'LP_E1',
            to: ['LP_S']
          }
        ]
      },
      {
        action: PCReason.ActionEnum.L,
        tables: [
          {
            from: 'LP_S',
            to: ['LN_AO', 'LN_AI', 'LN_LO', 'LN_LI']
          }
        ]
      }
    ]

  export const TableMapData = new Map<PCReason.ActionEnum, Map<string, string[]>>(
    RawTableCode.map((item) => [
      item.action,
      new Map<string, string[]>(item.tables.map((table) => [table.from, table.to]))
    ])
  )

  export const getJournalToPair = (action: PCReason.ActionEnum) => (code: string) =>
    TableMapData.get(action)?.get(code) ?? []

  export const getAvailableSacCodeFrom = (action: PCReason.ActionEnum) => {
    const a = TableMapData.get(action)
    const keys = Array.from(new Set(Array.from(a?.keys() ?? []).map((k) => k.split('_')[0])))
    const options = keys.map((k) => SacsData.getSacsCodeByCode(k)('vi'))
    return options
  }

  export const getAvailableSacTypeFrom = (action: PCReason.ActionEnum) => (sacCode: string) => {
    const a = TableMapData.get(action)
    const keys = Array.from(new Set(a?.keys() ?? []))
      .filter((k) => k.includes(sacCode ?? 'Null'))
      .map((k) => k.split('_')[1])

    const options = keys.map((k) => SacsData.getSacsTypeByCode(k)('vi'))
    return options
  }

  export const getAvailableSacCodeTo = (action: PCReason.ActionEnum, sacCode: string, sacType: string) => {
    const a = getJournalToPair(action)(`${sacCode}_${sacType}`)

    const sacCodeKeys = Array.from(new Set(a.map((k) => k.split('_')[0])))
    const sacTypeKeys = Array.from(new Set(a.map((k) => k.split('_')[1])))
    const sacCodeOptions = sacCodeKeys.map((code) => SacsData.getSacsCodeByCode(code)('vi'))
    const sacTypeOptions = sacTypeKeys.map((code) => SacsData.getSacsTypeByCode(code)('vi'))
    return {
      sacCodeOptions,
      sacTypeOptions
    }
  }
}

// Temporary Harcode, waiting API
// export namespace InterestRateTable {
//   const dateFormat = 'MM/DD/yyyy'
//   const RawInterestRateTable = [
//     {
//       fromDate: '01/01/2013',
//       toDate: '30/09/2013',
//       rate: 11.0
//     },
//     {
//       fromDate: '01/10/2013',
//       toDate: '31/12/2014',
//       rate: 11.25
//     },
//     {
//       fromDate: '01/01/2015',
//       toDate: '30/11/2018',
//       rate: 11.0
//     },
//     {
//       fromDate: '01/12/2018',
//       toDate: '31/03/2020',
//       rate: 10.5
//     },
//     {
//       fromDate: '01/04/2020',
//       toDate: '30/09/2020',
//       rate: 10.0
//     },
//     {
//       fromDate: '01/10/2020',
//       toDate: '31/03/2022',
//       rate: 9.0
//     },
//     {
//       fromDate: '01/04/2022',
//       toDate: null,
//       rate: 8.5
//     }
//   ]

//   export const InterestRateTable = RawInterestRateTable.map((i) => ({
//     fromDate: moment(i.fromDate, dateFormat).toDate(),
//     toDate: i.toDate ? moment(i.toDate).toDate() : Date(),
//     rate: i.rate
//   }))

//   export const getRateByDate = (transactionDate: Date) => {
//     for (let i = 0; i < InterestRateTable.length; i++) {
//       const data = InterestRateTable[i]
//       const isBetween = moment(transactionDate).isBetween(data.fromDate, data.toDate)
//       if (isBetween) {
//         return data.rate
//       }
//     }

//     return 0
//   }
// }

export namespace PartnerChannel {
  export const RawParnerChannel: { bankCode: string; name: string; nameEn?: string }[] = [
    {
      bankCode: 'V2',
      name: 'MyVIB'
    },
    {
      bankCode: 'M2',
      name: 'Momo'
    },
    {
      bankCode: 'A9',
      name: 'VNPost'
    },
    {
      bankCode: 'S6',
      name: 'VBA'
    },
    {
      bankCode: 'L3',
      name: 'Viettel'
    },
    {
      bankCode: 'D7',
      name: 'POS SeaBank'
    },
    {
      bankCode: 'I2',
      name: 'Ebanking SeaBank'
    },
    {
      bankCode: 'O1',
      name: 'PruOnline - Thẻ quốc tế',
      nameEn: 'PruOnline - International Card (Visa/Mastercard)'
    },
    {
      bankCode: 'O2',
      name: 'PruOnline - Thẻ ATM',
      nameEn: 'PruOnline - Domestic Card (ATM)'
    },
    {
      bankCode: 'O3',
      name: 'Recurring'
    },
    {
      bankCode: 'DK',
      name: 'VNPay'
    },
    {
      bankCode: 'C9',
      name: 'Zalo'
    },
    // {
    //   bankCode: 'P2',
    //   name: 'Shopee'
    // },
    // {
    //   bankCode: 'M7',
    //   name: 'Mpos - Sacombank'
    // },
    // {
    //   bankCode: 'W1',
    //   name: 'Vietel-Telco'
    // },
    {
      bankCode: 'T3',
      name: 'TCB'
    },
    {
      bankCode: 'A7',
      name: 'Citi'
    },
    {
      bankCode: 'S1',
      name: 'Maritime'
    },
    {
      bankCode: 'P3',
      name: 'PVCombank'
    },
    {
      bankCode: 'S2',
      name: 'VCB'
    },
    {
      bankCode: 'B3',
      name: 'Seabank'
    },
    {
      bankCode: 'S3',
      name: 'Shinhan'
    },
    {
      bankCode: 'C3',
      name: 'SCB'
    },
    {
      bankCode: 'U3',
      name: 'UOBank'
    },
    {
      bankCode: 'V3',
      name: 'VIB'
    },
    {
      bankCode: 'I3',
      name: 'VietBank'
    },
    {
      bankCode: 'C7',
      name: 'POS Eximbank'
    },
    {
      bankCode: 'X1',
      name: 'Auto debit VCB'
    },
    // {
    //   bankCode: 'A0',
    //   name: 'ShopeePay'
    // },
    {
      bankCode: 'I4',
      name: 'MSB BANK'
    },
    // {
    //   bankCode: 'M3',
    //   name: 'MOMO FOR AGENT'
    // },
    {
      bankCode: 'P9',
      name: 'Payoo'
    },
    {
      bankCode: 'V4',
      name: 'VIB AUTODEBIT'
    },
    {
      bankCode: 'M9',
      name: 'Momo PruOnline'
    },
    {
      bankCode: 'D6',
      name: 'Sacombank App'
    },
    {
      bankCode: 'D8',
      name: 'Sacombank Counter'
    },
    {
      bankCode: 'D9',
      name: 'Sacombank Banktransfer'
    },
    {
      bankCode: 'V5',
      name: 'Credit Life Portal'
    },
    // {
    //   bankCode: 'V4',
    //   name: 'VIB AUTODEBIT'
    // }
    {
      bankCode: 'Q2',
      name: 'HSBC - QR Code'
    },
    {
      bankCode: 'O1',
      name: 'PruServices - Thẻ quốc tế'
    },
    {
      bankCode: 'O2',
      name: 'PruServices - Thẻ ATM'
    },
    {
      bankCode: 'M9',
      name: 'PruServices - Momo'
    },
    {
      bankCode: 'DK',
      name: 'PruServices - VNPay'
    }
  ]

  export const ParnerChannelConst: Array<{
    bankCode: string
    VI_UIName: string
    EN_UIName: string
    channelOriginalName?: string
    source: SourceType
  }> = [
      {
        bankCode: 'T3',
        VI_UIName: 'Offline (TCB)',
        EN_UIName: 'Offline (TCB)',
        source: SourceType.Offline
      },
      {
        bankCode: 'A7',
        VI_UIName: 'Offline (Citi)',
        EN_UIName: 'Offline (Citi)',
        source: SourceType.Offline
      },
      {
        bankCode: 'S1',
        VI_UIName: 'Offline (Maritime)',
        EN_UIName: 'Offline (Maritime)',
        source: SourceType.Offline
      },
      {
        bankCode: 'P3',
        VI_UIName: 'Offline (PVCombank)',
        EN_UIName: 'Offline (PVCombank)',
        source: SourceType.Offline
      },
      {
        bankCode: 'S2',
        VI_UIName: 'Offline (VCB)',
        EN_UIName: 'Offline (VCB)',
        source: SourceType.Offline
      },
      {
        bankCode: 'B3',
        VI_UIName: 'Offline (Seabank)',
        EN_UIName: 'Offline (Seabank)',
        source: SourceType.Offline
      },
      {
        bankCode: 'S3',
        VI_UIName: 'Offline (Sinhan)',
        EN_UIName: 'Offline (Sinhan)',
        source: SourceType.Offline
      },
      {
        bankCode: 'C3',
        VI_UIName: 'Offline (SCB)',
        EN_UIName: 'Offline (SCB)',
        source: SourceType.Offline
      },
      {
        bankCode: 'U3',
        VI_UIName: 'Offline (UOBank)',
        EN_UIName: 'Offline (UOBank)',
        source: SourceType.Offline
      },
      {
        bankCode: 'V3',
        VI_UIName: 'Offline (VIB)',
        EN_UIName: 'Offline (VIB)',
        source: SourceType.Offline
      },
      {
        bankCode: 'I3',
        VI_UIName: 'Offline (VietBank)',
        EN_UIName: 'Offline (VietBank)',
        source: SourceType.Offline
      },
      {
        bankCode: 'C7',
        VI_UIName: 'Offline (POS Eximbank)',
        EN_UIName: 'Offline (POS Eximbank)',
        source: SourceType.Offline
      },
      {
        bankCode: 'X1',
        VI_UIName: 'Offline (Auto debit VCB)',
        EN_UIName: 'Offline (Auto debit VCB)',
        source: SourceType.Offline
      },
      {
        bankCode: 'S6',
        VI_UIName: 'Offline (VBA)',
        EN_UIName: 'Offline (VBA)',
        source: SourceType.Offline
      },
      {
        bankCode: 'L3',
        VI_UIName: 'Offline (Viettel)',
        EN_UIName: 'Offline (Viettel)',
        source: SourceType.Offline
      },
      {
        bankCode: 'D7',
        VI_UIName: 'Offline (POS SeaBank)',
        EN_UIName: 'Offline (POS SeaBank)',
        source: SourceType.Offline
      },
      {
        bankCode: 'I2',
        VI_UIName: 'Offline (Ebanking SeaBank)',
        EN_UIName: 'Offline (Ebanking SeaBank)',
        source: SourceType.Offline
      },
      {
        bankCode: 'O1',
        VI_UIName: 'Offline (PruOnline - Thẻ quốc tế)',
        EN_UIName: 'Offline (PruOnline - International Card (Visa/Mastercard))',
        source: SourceType.Offline
      },
      {
        bankCode: 'O2',
        VI_UIName: 'Offline (PruOnline - Thẻ ATM)',
        EN_UIName: 'Offline (PruOnline - Domestic Card (ATM))',
        source: SourceType.Offline
      },
      {
        bankCode: 'O3',
        VI_UIName: 'Offline (Recurring)',
        EN_UIName: 'Offline (Recurring)',
        source: SourceType.Offline
      },
      {
        bankCode: 'DK',
        VI_UIName: 'Offline (VNPay)',
        EN_UIName: 'Offline (VNPay)',
        source: SourceType.Offline
      },
      {
        bankCode: 'C9',
        VI_UIName: 'Offline (Zalo)',
        EN_UIName: 'Offline (Zalo)',
        source: SourceType.Offline
      },
      {
        bankCode: 'P2',
        VI_UIName: 'Offline (Shopee)',
        EN_UIName: 'Offline (Shopee)',
        source: SourceType.Offline
      },
      {
        bankCode: 'M7',
        VI_UIName: 'Offline (MPOS - Sacombank)',
        EN_UIName: 'Offline (MPOS - Sacombank)',
        source: SourceType.Offline
      },
      {
        bankCode: 'W1',
        VI_UIName: 'Offline (Viettel-Telco)',
        EN_UIName: 'Offline (Viettel-Telco)',
        source: SourceType.Offline
      },
      {
        bankCode: 'V2',
        VI_UIName: 'Offline (MyVIB)',
        EN_UIName: 'Offline (MyVIB)',
        source: SourceType.Offline
      },
      {
        bankCode: 'M2',
        VI_UIName: 'Offline (Momo)',
        EN_UIName: 'Offline (Momo)',
        source: SourceType.Offline
      },
      {
        bankCode: 'A9',
        VI_UIName: 'Offline (VNPost)',
        EN_UIName: 'Offline (VNPost)',
        source: SourceType.Offline
      },
      {
        bankCode: 'A0',
        VI_UIName: 'Offline (ShopeePay)',
        EN_UIName: 'Offline (ShopeePay)',
        source: SourceType.Offline
      },
      {
        bankCode: 'I4',
        VI_UIName: 'Offline (MSB BANK)',
        EN_UIName: 'Offline (MSB BANK)',
        source: SourceType.Offline
      },
      {
        bankCode: 'M3',
        VI_UIName: 'Offline (MOMO FOR AGENT)',
        EN_UIName: 'Offline (MOMO FOR AGENT)',
        source: SourceType.Offline
      },
      {
        bankCode: 'P9',
        VI_UIName: 'Offline (PAYOO)',
        EN_UIName: 'Offline (PAYOO)',
        source: SourceType.Offline
      },
      {
        bankCode: 'V4',
        VI_UIName: 'Offline (VIB AUTODEBIT)',
        EN_UIName: 'Offline (VIB AUTODEBIT)',
        source: SourceType.Offline
      },
      {
        bankCode: 'S6',
        VI_UIName: 'Offline (VBA)',
        EN_UIName: 'Offline (VBA)',
        source: SourceType.Offline
      },
      {
        bankCode: 'M9',
        VI_UIName: 'Offline (Momo PruOnline)',
        EN_UIName: 'Offline (Momo PruOnline)',
        source: SourceType.Offline
      },
      {
        bankCode: 'D6',
        VI_UIName: 'Offline (Sacombank App)',
        EN_UIName: 'Offline (Sacombank App)',
        source: SourceType.Offline
      },
      {
        bankCode: 'D8',
        VI_UIName: 'Offline (Sacombank Counter)',
        EN_UIName: 'Offline (Sacombank Counter)',
        source: SourceType.Offline
      },
      {
        bankCode: 'D9',
        VI_UIName: 'Offline (Sacombank Banktransfer)',
        EN_UIName: 'Offline (Sacombank Banktransfer)',
        source: SourceType.Offline
      },
      {
        bankCode: 'Q2',
        VI_UIName: 'Offline (HSBC - QR Code)',
        EN_UIName: 'Offline (HSBC - QR Code)',
        source: SourceType.Offline
      },
      {
        bankCode: 'L3',
        VI_UIName: 'Viettel',
        EN_UIName: 'Viettel',
        source: SourceType.Viettel
      },
      {
        bankCode: 'D7',
        VI_UIName: 'POS SeaBank',
        EN_UIName: 'POS SeaBank',
        source: SourceType.POS_SeABank
      },
      {
        bankCode: 'I2',
        VI_UIName: 'Ebanking SeaBank',
        EN_UIName: 'Ebanking SeaBank',
        source: SourceType.Ebanking_seabank
      },
      {
        bankCode: 'O1',
        VI_UIName: 'PruOnline - Thẻ quốc tế',
        EN_UIName: 'PruOnline - International Card (Visa/Mastercard)',
        source: SourceType.PRUONLINE
      },
      {
        bankCode: 'O2',
        VI_UIName: 'PruOnline - Thẻ ATM',
        EN_UIName: 'PruOnline - Domestic Card (ATM)',
        source: SourceType.PRUONLINE
      },
      {
        bankCode: 'O3',
        VI_UIName: 'Recurring',
        EN_UIName: 'Recurring',
        source: SourceType.PRUONLINE
      },
      {
        bankCode: 'DK',
        VI_UIName: 'VNPay',
        EN_UIName: 'VNPay',
        source: SourceType.PRUONLINE
      },
      {
        bankCode: 'C9',
        VI_UIName: 'Zalo',
        EN_UIName: 'Zalo',
        source: SourceType.PRUONLINE
      },
      {
        bankCode: 'P2',
        VI_UIName: 'Shopee',
        EN_UIName: 'Shopee',
        source: SourceType.Shopee
      },
      {
        bankCode: 'M7',
        VI_UIName: 'MPOS - Sacombank',
        EN_UIName: 'MPOS - Sacombank',
        source: SourceType.MPOS_EXIMBANK
      },
      {
        bankCode: 'W1',
        VI_UIName: 'Viettel-Telco',
        EN_UIName: 'Viettel-Telco',
        source: SourceType.VIETTEL_TELCO
      },
      {
        bankCode: 'V2',
        VI_UIName: 'MyVIB',
        EN_UIName: 'MyVIB',
        source: SourceType.MY_VIB
      },
      {
        bankCode: 'M2',
        VI_UIName: 'Momo',
        EN_UIName: 'Momo',
        source: SourceType.MOMO
      },
      {
        bankCode: 'A9',
        VI_UIName: 'VNPost',
        EN_UIName: 'VNPost',
        source: SourceType.VNPOST
      },
      {
        bankCode: 'A0',
        VI_UIName: 'ShopeePay',
        EN_UIName: 'ShopeePay',
        source: SourceType.ShopeePay
      },
      {
        bankCode: 'I4',
        VI_UIName: 'MSB BANK',
        EN_UIName: 'MSB BANK',
        source: SourceType.MSB_BANK
      },
      {
        bankCode: 'M3',
        VI_UIName: 'MOMO FOR AGENT',
        EN_UIName: 'MOMO FOR AGENT',
        source: SourceType.MOMO_FOR_AGENT
      },
      {
        bankCode: 'P9',
        VI_UIName: 'PAYOO',
        EN_UIName: 'PAYOO',
        source: SourceType.PAYOO
      },
      {
        bankCode: 'V4',
        VI_UIName: 'VIB AUTODEBIT',
        EN_UIName: 'VIB AUTODEBIT',
        source: SourceType.VIB_AUTODEBIT
      },
      {
        bankCode: 'S6',
        VI_UIName: 'VBA',
        EN_UIName: 'VBA',
        source: SourceType.Agribank_VBA
      },
      {
        bankCode: 'M9',
        VI_UIName: 'Momo PruOnline',
        EN_UIName: 'Momo PruOnline',
        source: SourceType.PRUONLINE
      },
      {
        bankCode: 'D6',
        VI_UIName: 'Sacombank App',
        EN_UIName: 'Sacombank App',
        source: SourceType.SACOMBANK
      },
      {
        bankCode: 'D8',
        VI_UIName: 'Sacombank Counter',
        EN_UIName: 'Sacombank Counter',
        source: SourceType.SACOMBANK
      },
      {
        bankCode: 'D9',
        VI_UIName: 'Sacombank Banktransfer',
        EN_UIName: 'Sacombank Banktransfer',
        source: SourceType.SACOMBANK
      },
      {
        bankCode: 'V5',
        VI_UIName: 'Credit life portal',
        EN_UIName: 'Credit life portal',
        channelOriginalName: 'VIB',
        source: SourceType.CREDITLIFEPORTAL
      },
      {
        bankCode: 'Q2',
        VI_UIName: 'HSBC - QR Code',
        EN_UIName: 'HSBC - QR Code',
        channelOriginalName: 'HSBC',
        source: SourceType.HSBC_BANK
      },
      {
        bankCode: 'O1',
        VI_UIName: 'PruServices - Thẻ quốc tế',
        EN_UIName: 'PruServices - Thẻ quốc tế',
        source: SourceType.PRUSERVICES
      },
      {
        bankCode: 'O2',
        VI_UIName: 'PruServices - Thẻ ATM',
        EN_UIName: 'PruServices - Thẻ ATM',
        source: SourceType.PRUSERVICES
      },
      {
        bankCode: 'M9',
        VI_UIName: 'PruServices - Momo',
        EN_UIName: 'PruServices - Momo',
        channelOriginalName: 'Momo',
        source: SourceType.PRUSERVICES
      },
      {
        bankCode: 'DK',
        VI_UIName: 'PruServices - VNPay',
        EN_UIName: 'PruServices - VNPay',
        channelOriginalName: 'VNPay',
        source: SourceType.PRUSERVICES
      },
      {
        bankCode: 'T3',
        VI_UIName: 'PC Web (TCB)',
        EN_UIName: 'PC Web (TCB)',
        channelOriginalName: 'PC Web (TCB)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'A7',
        VI_UIName: 'PC Web (Citi)',
        EN_UIName: 'PC Web (Citi)',
        channelOriginalName: 'PC Web (Citi)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'S1',
        VI_UIName: 'PC Web (Maritime)',
        EN_UIName: 'PC Web (Maritime)',
        channelOriginalName: 'PC Web (Maritime)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'P3',
        VI_UIName: 'PC Web (PVCombank)',
        EN_UIName: 'PC Web (PVCombank)',
        channelOriginalName: 'PC Web (PVCombank)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'S2',
        VI_UIName: 'PC Web (VCB)',
        EN_UIName: 'PC Web (VCB)',
        channelOriginalName: 'PC Web (VCB)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'B3',
        VI_UIName: 'PC Web (Seabank)',
        EN_UIName: 'PC Web (Seabank)',
        channelOriginalName: 'PC Web (Seabank)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'S3',
        VI_UIName: 'PC Web (Sinhan)',
        EN_UIName: 'PC Web (Sinhan)',
        channelOriginalName: 'PC Web (Sinhan)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'C3',
        VI_UIName: 'PC Web (SCB)',
        EN_UIName: 'PC Web (SCB)',
        channelOriginalName: 'PC Web (SCB)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'U3',
        VI_UIName: 'PC Web (UOBank)',
        EN_UIName: 'PC Web (UOBank)',
        channelOriginalName: 'PC Web (UOBank)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'V3',
        VI_UIName: 'PC Web (VIB)',
        EN_UIName: 'PC Web (VIB)',
        channelOriginalName: 'PC Web (VIB)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'I3',
        VI_UIName: 'PC Web (VietBank)',
        EN_UIName: 'PC Web (VietBank)',
        channelOriginalName: 'PC Web (VietBank)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'C7',
        VI_UIName: 'PC Web (POS Eximbank)',
        EN_UIName: 'PC Web (POS Eximbank)',
        channelOriginalName: 'PC Web (POS Eximbank)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'X1',
        VI_UIName: 'PC Web (Auto debit VCB)',
        EN_UIName: 'PC Web (Auto debit VCB)',
        channelOriginalName: 'PC Web (Auto debit VCB)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'S6',
        VI_UIName: 'PC Web (VBA)',
        EN_UIName: 'PC Web (VBA)',
        channelOriginalName: 'PC Web (VBA)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'L3',
        VI_UIName: 'PC Web (Viettel)',
        EN_UIName: 'PC Web (Viettel)',
        channelOriginalName: 'PC Web (Viettel)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'D7',
        VI_UIName: 'PC Web (POS SeaBank)',
        EN_UIName: 'PC Web (POS SeaBank)',
        channelOriginalName: 'PC Web (POS SeaBank)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'I2',
        VI_UIName: 'PC Web (Ebanking SeaBank)',
        EN_UIName: 'PC Web (Ebanking SeaBank)',
        channelOriginalName: 'PC Web (Ebanking SeaBank)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'O1',
        VI_UIName: 'PC Web (PruOnline - Thẻ quốc tế)',
        EN_UIName: 'PC Web (PruOnline - Thẻ quốc tế)',
        channelOriginalName: 'PC Web (PruOnline - Thẻ quốc tế)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'O2',
        VI_UIName: 'PC Web (PruOnline - Thẻ ATM)',
        EN_UIName: 'PC Web (PruOnline - Thẻ ATM)',
        channelOriginalName: 'PC Web (PruOnline - Thẻ ATM)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'O3',
        VI_UIName: 'PC Web (Recurring)',
        EN_UIName: 'PC Web (Recurring)',
        channelOriginalName: 'PC Web (Recurring)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'DK',
        VI_UIName: 'PC Web (VNPay)',
        EN_UIName: 'PC Web (VNPay)',
        channelOriginalName: 'PC Web (VNPay)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'C9',
        VI_UIName: 'PC Web (Zalo)',
        EN_UIName: 'PC Web (Zalo)',
        channelOriginalName: 'PC Web (Zalo)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'P2',
        VI_UIName: 'PC Web (Shopee)',
        EN_UIName: 'PC Web (Shopee)',
        channelOriginalName: 'PC Web (Shopee)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'M7',
        VI_UIName: 'PC Web (MPOS - Sacombank)',
        EN_UIName: 'PC Web (MPOS - Sacombank)',
        channelOriginalName: 'PC Web (MPOS - Sacombank)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'W1',
        VI_UIName: 'PC Web (Viettel-Telco)',
        EN_UIName: 'PC Web (Viettel-Telco)',
        channelOriginalName: 'PC Web (Viettel-Telco)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'V2',
        VI_UIName: 'PC Web (MyVIB)',
        EN_UIName: 'PC Web (MyVIB)',
        channelOriginalName: 'PC Web (MyVIB)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'M2',
        VI_UIName: 'PC Web (Momo)',
        EN_UIName: 'PC Web (Momo)',
        channelOriginalName: 'PC Web (Momo)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'A9',
        VI_UIName: 'PC Web (VNPost)',
        EN_UIName: 'PC Web (VNPost)',
        channelOriginalName: 'PC Web (VNPost)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'A0',
        VI_UIName: 'PC Web (ShopeePay)',
        EN_UIName: 'PC Web (ShopeePay)',
        channelOriginalName: 'PC Web (ShopeePay)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'I4',
        VI_UIName: 'PC Web (MSB BANK)',
        EN_UIName: 'PC Web (MSB BANK)',
        channelOriginalName: 'PC Web (MSB BANK)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'M3',
        VI_UIName: 'PC Web (MOMO FOR AGENT)',
        EN_UIName: 'PC Web (MOMO FOR AGENT)',
        channelOriginalName: 'PC Web (MOMO FOR AGENT)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'P9',
        VI_UIName: 'PC Web (PAYOO)',
        EN_UIName: 'PC Web (PAYOO)',
        channelOriginalName: 'PC Web (PAYOO)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'V4',
        VI_UIName: 'PC Web (VIB AUTODEBIT)',
        EN_UIName: 'PC Web (VIB AUTODEBIT)',
        channelOriginalName: 'PC Web (VIB AUTODEBIT)',
        source: SourceType.PCWEB
      },
      {
        bankCode: 'S6',
        VI_UIName: 'PC Web (VBA)',
        EN_UIName: 'PC Web (VBA)',
        channelOriginalName: 'PC Web (VBA)',
        source: SourceType.PCWEB
      },

    ]

  const MapPartnerChannel: Map<string, Map<string, string>> = new Map(
    RawParnerChannel.map((item) => [
      item.bankCode,
      new Map([
        ['en', item.nameEn ?? item.name],
        ['vi', item.name]
      ])
    ])
  )

  export const getPartnerNameByCode = (code: string) => (languageCode: string) =>
    MapPartnerChannel.get(code)?.get(languageCode) ?? code

  export const getNewPartnerChannelName = (bankCode: string, sourceType: string) => (languageCode: string) => {
    const partnerName = pipe(
      ParnerChannelConst.find((item) => item.bankCode === bankCode && item.source === sourceType),
      O.fromNullable,
      O.fold(
        () => '',
        (item) => languageCode === 'vi' ? item.VI_UIName : item.EN_UIName
      )
    )
    return partnerName
  }
}
